<template>
    <router-view />
</template>

<script>
    export default {
        name: "MainLayout"
    }
</script>

<style scoped>

</style>